<hlm-dialog [state]="open() ? 'open' : 'closed'" (stateChanged)="onDialogState($event)">
  <hlm-dialog-content *hlmDialogPortal class="max-h-[90vh] max-w-3xl overflow-y-auto">
    <div hlmDialogHeader>
      <h3 hlmDialogTitle>Bilder</h3>
      <p hlmDialogDescription>
        Deine Bilder für alle Designs. Klicke ein Bild an, um es zu verwenden. PNG, JPEG oder WebP
        bis 15 MB, auch HEIC vom iPhone; große Bilder werden auf 2000 Pixel verkleinert.
      </p>
    </div>

    @if (error(); as message) {
      <div hlmAlert variant="destructive">
        <ng-icon name="lucideTriangleAlert" />
        <p hlmAlertDescription>{{ message }}</p>
      </div>
    }

    @if (images(); as images) {
      @if (images.length === 0) {
        <hlm-empty class="py-8">
          <div hlmEmptyHeader>
            <div hlmEmptyMedia variant="icon"><ng-icon name="lucideImagePlus" /></div>
            <p hlmEmptyTitle>Noch keine Bilder</p>
            <p hlmEmptyDescription>Lade ein Bild hoch, um es auf dem Design zu platzieren.</p>
          </div>
        </hlm-empty>
      } @else {
        <ul class="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4">
          @for (image of images; track image.public_id) {
            <li class="flex flex-col gap-1">
              <button
                type="button"
                class="bg-muted hover:ring-primary focus-visible:ring-primary relative aspect-square w-full overflow-hidden rounded border hover:ring-2 focus-visible:ring-2 focus-visible:outline-none"
                [attr.aria-label]="'Bild verwenden, ' + sizeLabel(image)"
                (click)="pick.emit(image)">
                <app-authenticated-image
                  class="absolute inset-0 h-full w-full"
                  [src]="fileUrl(image)"
                  [retry]="false"
                  alt="" />
              </button>
              <div class="flex items-center justify-between gap-1">
                <span hlmMuted class="text-xs">{{ sizeLabel(image) }}</span>
                @if (confirmDeleteId() === image.public_id) {
                  <span class="flex items-center gap-1">
                    <button
                      hlmBtn
                      variant="destructive"
                      size="sm"
                      type="button"
                      (click)="confirmDelete(image)">
                      Löschen
                    </button>
                    <button
                      hlmBtn
                      variant="ghost"
                      size="sm"
                      type="button"
                      (click)="confirmDeleteId.set(null)">
                      Nein
                    </button>
                  </span>
                } @else {
                  <button
                    hlmBtn
                    variant="ghost"
                    size="icon-sm"
                    type="button"
                    aria-label="Bild löschen"
                    [disabled]="usedIds().has(image.public_id) || deletingId() !== null"
                    [hlmTooltip]="'Im aktuellen Layout verwendet'"
                    [tooltipDisabled]="!usedIds().has(image.public_id)"
                    (click)="askDelete(image)">
                    @if (deletingId() === image.public_id) {
                      <hlm-spinner />
                    } @else {
                      <ng-icon name="lucideTrash2" />
                    }
                  </button>
                }
              </div>
            </li>
          }
        </ul>
      }
    } @else if (!error()) {
      <div class="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-4" aria-busy="true">
        <hlm-skeleton class="aspect-square w-full" />
        <hlm-skeleton class="aspect-square w-full" />
        <hlm-skeleton class="aspect-square w-full" />
        <hlm-skeleton class="aspect-square w-full" />
      </div>
    }

    <input
      #fileInput
      type="file"
      class="sr-only"
      accept="image/png,image/jpeg,image/webp,image/heic,image/heif,.png,.jpg,.jpeg,.webp,.heic,.heif"
      aria-label="Bild auswählen"
      (change)="onFileSelected($event)" />

    <div hlmDialogFooter>
      <button hlmBtn variant="outline" type="button" (click)="close.emit()">Schließen</button>
      <button
        hlmBtn
        type="button"
        [disabled]="uploading() || full()"
        [hlmTooltip]="'Höchstens ' + maxImages() + ' Bilder. Bitte zuerst eines löschen.'"
        [tooltipDisabled]="!full()"
        (click)="openPicker()">
        @if (uploading()) {
          <hlm-spinner />
        } @else {
          <ng-icon name="lucideImagePlus" />
        }
        Bild hochladen
      </button>
    </div>
  </hlm-dialog-content>
</hlm-dialog>
